import { Progress, Typography } from "@shared/ui";
import styles from "./ExtractionProgress.module.scss";

const { Text } = Typography;

type ExtractionProgressProps = {
  isLoading: boolean;
};

export function ExtractionProgress({ isLoading }: ExtractionProgressProps) {
  if (!isLoading) {
    return null;
  }

  return (
    <div className={styles.progress}>
      <Progress percent={70} status="active" showInfo={false} />
      <Text className={styles.status}>
        Extracting videos, channel statistics, and engagement rates...
      </Text>
    </div>
  );
}
